import { FC, useState } from 'react';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { PageContent } from 'templates/PageContent';
import { Form } from 'templates/Form';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppFooter } from 'templates/AppFooter';
import { TransitionButton } from 'atoms/TransitionButton';
import { Button } from 'atoms/Button';
import { parsePhoneNumber } from 'react-phone-number-input';
import { Trans } from 'react-i18next';

const REFETCH_INTERVAL = 30;

//U002F06 認証再送信画面
type AuthenticationResubmissionProps = {
  setIsSubmitted: (isSubmitted: boolean) => void;
  onClickSubmit: () => void;
  phoneNumber: string;
};
export const AuthenticationResubmission: FC<AuthenticationResubmissionProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const { setIsSubmitted, onClickSubmit, phoneNumber } = props;
  const [isDisabled, setIsDisabled] = useState(true);
  const parsedPhoneNumber = parsePhoneNumber(phoneNumber);

  // 画面表示時と再送信ボタン押下時に一時的に非活性にする
  if (isDisabled) {
    setTimeout(() => setIsDisabled(false), 1000 * REFETCH_INTERVAL);
  }

  const handleOnClickSubmit = () => {
    onClickSubmit();
    setIsDisabled(true);
  };
  return (
    <>
      <AppLogoHeader />
      <main>
        <h1 className="sr-only" aria-live="assertive">
          {tAuditionForm('TU002_009')}
        </h1>
        <PageContent>
          <Form title={tAuditionForm('TU002_009')}>
            <div className={'flex justify-center items-center flex-col'}>
              <div className={'text-center'} aria-live="polite">
                {parsedPhoneNumber?.country === 'JP' || parsedPhoneNumber?.country === 'TW' ? (
                  <p>{tAuditionForm('TU002_065')}</p>
                ) : (
                  <p>{tAuditionForm('TU002_134')}</p>
                )}
                <p>{tAuditionForm('TU002_066')}</p>
                <p>{tAuditionForm('TU002_067')}</p>
                <Trans t={tAuditionForm} i18nKey={'TU002_142'} />
              </div>
              <div className={'flex justify-center items-center mt-10'}>
                <TransitionButton
                  className="w-[10rem] mr-6"
                  label={tAuditionForm('TU002_030')}
                  onClick={() => setIsSubmitted(false)}
                />
                <Button
                  className="w-[10rem]"
                  label={tAuditionForm('TU002_068')}
                  type="submit"
                  onClick={handleOnClickSubmit}
                  disabled={isDisabled}
                />
              </div>
            </div>
          </Form>
        </PageContent>
      </main>
      <AppFooter />
    </>
  );
};
